import {
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { ConvertDate } from '../shared/date/convertDate';
import { TokenParser } from '../shared/auth/token-parser';
import { KeyValue } from '@angular/common';
import { AccountService } from '../shared/account/account.service';
import { IdTokenClaims } from '@azure/msal-common';
import { MsalBroadcastService } from '@azure/msal-angular';
import {
  AuthenticationResult,
  EventMessage,
  EventType,
} from '@azure/msal-browser';
import {
  filter,
  Subject,
  takeUntil,
} from 'rxjs';

@Component({
  selector: 'claims',
  templateUrl: './claims.component.html',
  styleUrls: ['./claims.component.css']
})

/*
 * Access to this component is protected by MsalGuard.
 * 
 * "MsalGuard is a convenience class you can use to improve the user experience, but 
 * it should not be relied upon for security. Attackers can potentially get around
 * client-side guards, and you should ensure that the server does not return any data
 * the user should not access. You may also need a route guard that addresses specific
 * needs. We encourage you to write your own guard if MsalGuard does not meet all those needs." 
 * (https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-angular/docs/v2-docs/msal-guard.md)
 */
export class ClaimsComponent implements OnInit, OnDestroy {
  idTokenClaims: IdTokenClaims;
  accessToken: object;
  convertDate: ConvertDate;
  tokenParser: TokenParser;
  private readonly _destroying$ = new Subject<void>();

  constructor(
    private accountService: AccountService,
    private msalBroadcastService: MsalBroadcastService,) {

    this.convertDate = new ConvertDate();
    this.tokenParser = new TokenParser();
  }

  ngOnInit(): void {
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS
          || msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS
          || msg.eventType === EventType.SSO_SILENT_SUCCESS),
        takeUntil(this._destroying$)
      )
      .subscribe((result: EventMessage) => {
        const authPayload = result.payload as AuthenticationResult;

        const encodedAccessToken = authPayload.accessToken;
        if (encodedAccessToken) {
          this.accessToken = this.tokenParser.ParseTokenClaims(encodedAccessToken);
        }
      });

    this.accountService.acquireTokenSilent();
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

  printClaimValue(claimKeyValue: KeyValue<string, string>) {
    let claimKey = claimKeyValue.key;
    if ((claimKey == 'auth_time')
      || (claimKey == 'exp')
      || (claimKey == 'iat')
      || (claimKey == 'nbf')) {

      return this.convertDate.ConvertFromEpochString(claimKeyValue.value);
    }

    return claimKeyValue.value;
  }
}
